import React from 'react'
import ReactDom from 'react-dom'
import Item from './Item'
import { trackEvent } from '../../utilities/analytics'

class Select extends React.Component {

  constructor(props) {
    super(props)

    this.scrolling = null

    this.handleChange = this.handleChange.bind(this)
    this.handleArrowClick = this.handleArrowClick.bind(this)
    this.handleArrowDown = this.handleArrowDown.bind(this)
    this.handleArrowUp = this.handleArrowUp.bind(this)

    this.scrollAmount = this.scrollAmount.bind(this)
    this.scrollClear = this.scrollClear.bind(this)
    this.scrollInterval = this.scrollInterval.bind(this)
    this.scrollTimeoutToInterval = this.scrollTimeoutToInterval.bind(this)
    this.scrollToFloor = this.scrollToFloor.bind(this)
  }

  componentDidMount() {
    let {
      currentFloor
    } = this.props

    this.scrollToFloor(currentFloor)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.config !== this.props.config
    || nextProps.currentFloor !== this.props.currentFloor
    || nextProps.direction !== this.props.direction
    || nextProps.displayCount !== this.props.displayCount
    || nextProps.height !== this.props.height
    || nextProps.input !== this.props.input
    || nextProps.units !== this.props.units
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.currentFloor !== this.props.currentFloor) {
      let {
        currentFloor
      } = nextProps

      this.scrollToFloor(currentFloor)
    }
  }

  getNumberFloorPickerHeight() {
    let {
      config,
      height
    } = this.props

    let paddingTopAndBottom = 30
    let floorSelectHeadlineHeight = 40
    let numberFloorPickerHeight = height - floorSelectHeadlineHeight - paddingTopAndBottom
    if (config.scrollType === 'arrows') {
      let scrollButtonHeight = 62
      numberFloorPickerHeight -= (scrollButtonHeight * 2)
    }

    return numberFloorPickerHeight
  }

  handleArrowClick(event) {
    event.preventDefault()
  }

  handleArrowDown(event) {
    event.preventDefault()

    if (this.scrolling === null) {
      let target = event.target
      var amountToScroll = target.scrollHeight
      if (target.id === 'upBtn') {
        amountToScroll *= -1
      }

      this.scrollAmount(amountToScroll)

      this.scrollTimeoutToInterval(amountToScroll)
    }
  }

  handleArrowUp(event) {
    event.preventDefault()

    this.scrollClear()
  }

  handleChange(event) {
    if (this.props.onChange) {
      event.preventDefault()

      const value = event.currentTarget.getAttribute('data-value')

      trackEvent({
        category: 'Floor List',
        action: 'Click',
        label: `Floor ${value}`
      })

      this.props.onChange({
        valueFor: 'floor',
        value: value
      })
    }
  }

  scrollAmount(amountToScroll) {
    let numberFloorPicker = this.refs.numberFloorPicker

    numberFloorPicker.scrollTop += amountToScroll
  }

  scrollClear() {
    if (this.scrolling.type === 'timeout') {
      window.clearTimeout(this.scrolling.id)
    } else if (this.scrolling.type === 'interval') {
      window.clearInterval(this.scrolling.id)
    }

    this.scrolling = null
  }

  scrollInterval(amountToScroll) {
    let intervalId = setInterval(() => {
      if (this.scrolling === null) {
        this.scrollClear()
      } else if (typeof this.scrolling.id === 'number') {
        this.scrollAmount(amountToScroll / 8)
      }
    }, 16)
    this.scrolling = {
      type: 'interval',
      id: intervalId
    }
  }

  scrollTimeoutToInterval(amountToScroll) {
    let intervalId = setTimeout(() => {
      if (this.scrolling === null) {
        this.scrollClear()
      } else if (typeof this.scrolling.id === 'number') {
        this.scrollInterval(amountToScroll)
      }
    }, 300)
    this.scrolling = {
      type: 'timeout',
      id: intervalId
    }
  }

  scrollToFloor(floor) {
    let floorElement = this.refs['floor' + floor]
    /**
     * This is a quick and dirty way to get the dom node of the child component.
     * By no way is this the best way, so feel free to fix
     * @author Patrick Douglas <pdouglas@engrain.com>
     */
    let floorElementDom = ReactDom.findDOMNode(floorElement)
    let offsetToCurrentFloor = floorElementDom.offsetTop + floorElementDom.offsetHeight

    let numberFloorPicker = this.refs.numberFloorPicker
    let toMiddleOfVisible = Math.round(numberFloorPicker.clientHeight / 2)

    numberFloorPicker.scrollTop = offsetToCurrentFloor - toMiddleOfVisible
  }

  render() {
    let {
      config,
      currentFloor,
      direction,
      displayCount,
      floors,
      height,
      input,
      units
    } = this.props

    if (direction === 'asc') {
      floors.sort((a, b) => (a.value - b.value))
    } else if (direction === 'desc') {
      floors.sort((a, b) => (b.value - a.value))
    }

    let numberFloorPickerHeight = this.getNumberFloorPickerHeight()

    return (
    <div id="floor-vertical-select">
      <div className="floor-select-headline">
        <p style={{'textAlign': displayCount ? 'left' : 'center'}}>
          <span style={{fontSize: '0.625rem'}}>Select a</span>
          <br/>
          <span>Floor</span>
        </p>
        {displayCount ? (
          <p>
            <span style={{fontSize: '0.625rem'}}>Available</span>
            <br/>
            <span>Units</span>
          </p>
        ) : null}
      </div>
      <hr/>
      { config.scrollType === 'arrows' ?
        <a
          id="upBtn"
          href="#"
          onClick={this.handleArrowClick}
          onMouseDown={this.handleArrowDown}
          onMouseUp={this.handleArrowUp}
          onTouchStart={this.handleArrowDown}
          onTouchEnd={this.handleArrowUp}
        >Up</a>
      : null }
      <div id="number-floor-picker" ref="numberFloorPicker" style={{height: numberFloorPickerHeight}}>
        <table>
          <tbody>
            {floors.map((floor, index) => {
               return <Item
                       currentFloor={currentFloor}
                       displayCount={displayCount}
                       floor={floor}
                       key={'floor' + floor.value}
                       onChange={this.handleChange}
                       ref={'floor' + floor.value}
                       unitCount={floor.count} />
             })}
          </tbody>
        </table>
      </div>
      { config.scrollType === 'arrows' ?
        <a
          id="downBtn"
          href="#"
          onClick={this.handleArrowClick}
          onMouseDown={this.handleArrowDown}
          onMouseUp={this.handleArrowUp}
          onTouchStart={this.handleArrowDown}
          onTouchEnd={this.handleArrowUp}
        >Down</a>
      : null }
    </div>
    )
  }
}

Select.defaultProps = {
  config: {},
  currentFloor: null,
  displayCount: true,
  direction: 'desc',
  floors: {},
  units: []
}

export default Select
